import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { kebabCase } from 'lodash/fp';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import navigationSelector from 'selectors/navigation';

// Components
import ModalMenu from 'components/modalMenu';

// Styles
import styles from './subNav.scss';

class SubNav extends React.Component {
  /**
   * Construct the component.
   * @param  {object} props Component props.
   * @return {void}
   */
  constructor(props) {
    super(props);

    // Bind methods
    this.itemsMap = this.itemsMap.bind(this);
    this.renderMenu = this.renderMenu.bind(this);
  }

  /**
   * Given an object, returns a list item component. Will call itself recursively
   * if the object contains more items.
   * @param  {string} item                item information.
   * @param  {string} type                type
   * @param  {Number} level               How many times this function has been
   *                                      invoked.
   * @return {object}                     Formatted list item.
   */
  itemsMap(item, type, level = 1) {
    const { match: { params: { category = 'usdata' } } } = this.props;
    const hasChildren = item.children && 0 < item.children.length;
    return (
      <li
        key={item.longTitle || item.geography}
        className={classNames(
          styles[`itemLevel${level}`],
          {
            [styles.isItemTerminalItem]: !hasChildren,
          }
        )}
      >
        <Link
          className={classNames(
            styles.link,
            styles[`linkLevel${level}`],
            { [styles.isParent]: hasChildren },
            { [styles.isTerminalItem]: !hasChildren }
          )}
          to={`/${category}/${type}/${item.slug || kebabCase(item.geography)}`}
        >
          {/* @todo this should be a heading tag for a11y */}
          {item.longTitle || item.geography}
        </Link>
        {hasChildren &&
          <ul
            className={classNames(
              styles.list,
              styles[`listLevel${level}`],
              {
                [styles.flatList]: !item.children.find(
                  (child) => child.children && 0 < child.children.length
                ),
                [styles.multiLevelList]: item.children.find(
                  (child) => child.children && 0 < child.children.length
                ),
              }
            )}
          >
            {item.children.map((child) =>
              this.itemsMap(child, type, level + 1))}
          </ul>
        }
      </li>
    );
  }

  renderMenu(type, label, title) {
    const items = this.props[type];
    if ('indicator' === type) {
      items.sort(({ index: a }, { index: b }) =>
        parseInt(a, 10) - parseInt(b, 10));
    }
    return (
      <li
        key={label}
        className={styles.buttonTriggerItem}
      >
        <ModalMenu label={label} title={title}>
          <ul
            className={classNames(
              styles.list,
              styles.listLevel0,
              {
                [styles.flatList]: !items.find((item) => item.children),
                [styles.multiLevelList]: items.find((item) => item.children),
              }
            )}
          >
            {items.map((item) => this.itemsMap(item, type))}
          </ul>
        </ModalMenu>
      </li>
    );
  }

  /**
   * Render the component.
   * @return {object}
   */
  render() {
    const {
      match: { params: { category = 'usdata' } },
      geography,
      indicator,
      className,
    } = this.props;

    return (
      <nav className={classNames(styles.subNav, className)}>
        <ul className={styles.buttonList}>
          {0 < indicator.length && this.renderMenu(
            'indicator',
            'Indicators',
            'usdata' === category ?
              'U.S. Indicators' : 'International Indicators'
          )}
          {0 < geography.length && this.renderMenu(
            'geography',
            'usdata' === category ? 'States' : 'Regions & Countries'
          )}
        </ul>
      </nav>
    );
  }
}

SubNav.defaultProps = {
  geography: [],
  indicator: [],
  className: '',
};

SubNav.propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  // These are used programatically
  geography: PropTypes.arrayOf(PropTypes.any),
  indicator: PropTypes.arrayOf(PropTypes.any),
  /* eslint-enable */
  match: PropTypes.shape({
    params: PropTypes.shape({
      category: PropTypes.string,
    }).isRequired,
  }).isRequired,
  className: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  const selector = navigationSelector(ownProps);
  return selector(state, ownProps);
};

export default withRouter(connect(mapStateToProps)(SubNav));



// WEBPACK FOOTER //
// ./app/components/subNav/index.js